module.exports = __webpack_public_path__ + "media/images/lb/465-33c3c47c7233cb232367fdfda5e52263.svg";